// extracted by mini-css-extract-plugin
module.exports = {"Actions":"CommentPopup_Actions__3I06d","Button":"CommentPopup_Button__3Ovfc"};